import {
  laptopMediumMax,
  largeTabletMax,
  mobileXXLargeMax,
  tabletMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import styled from 'styled-components';

export const SearchTitleWrapper = styled.div`
  padding: 30px 20px 0;

  @media (${laptopMediumMax}) {
    padding: 15px 15px 0;
  }
`;

export const ListSearchTitleWrapper = styled.div`
  @media (${mobileXXLargeMax}) {
    padding: 0 15px;
  }
`;

export const Container = styled.div<{ $onMap?: boolean }>`
  display: flex;
  justify-content: space-between;
  gap: 30px;
  height: 52px;

  ${({ $onMap }) =>
    $onMap &&
    `
    max-width: ${MAX_WIDTH - 30}px;
    margin: 0 auto;
    padding: 0 15px;
    
    @media (${largeTabletMax}) {
      display: none;
    }
  `}

  @media (${tabletMax}) {
    flex-direction: column;
    gap: 0;
    height: auto;
  }
`;

export const InfoContent = styled.div`
  max-width: ${MAX_WIDTH}px;
  display: flex;
  flex-direction: column;

  & > div {
    margin-top: 15px;
  }
`;

export const SideOptions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;

  button,
  a {
    display: flex;
    gap: 10px;
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme }) => theme.textDark};
    padding: 10px 5px;

    svg {
      font-size: 20px;
    }

    &:hover {
      color: ${({ theme }) => theme.primary};
    }
  }
`;
